

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import TeamRepository from "../services/TeamRepository";
import {Team} from "@/models/team.models";
import {ListCustomer} from "@/models/listCustomer";
import ZaloRepository from "@/services/ZaloRepository";
import {EmployeeCreate} from "@/models/employeeCreate";
import zaloRepository from "@/services/ZaloRepository";
import {GroupCreate} from "@/models/groupCreate";
import {Group} from "@/models/group";
import {MemberInGroupCreate} from "@/models/memberInGroupCreate";
import {MemberInGroup} from "@/models/memberInGroup";
import {ManagerOfGroupCreate} from "@/models/managerOfGroupCreate";
import {ManagerOfGroup} from "@/models/managerOfGroup";
import {Department} from "@/models/department";
import {EmployeeCheckIn} from "@/models/employeeCheckIn";
import {EmployeeLogin} from "@/models/employeeLogin";
import {useConfirm} from "primevue/useconfirm";
import axios from "axios";
import moment from "moment";
import {FileDetail} from "@/models/fileDetail.models";
import {EmployeeInHospital} from "@/models/employeeInHospital";

export default {

  setup(){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const listEmployee = ref([] as EmployeeInHospital[]);
    const employeeId = ref(0);

    const getListEmployee = () => {
      ZaloRepository.getListEmployeeInHospital()
          .then((response) => {
            listEmployee.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const createCheckIn = (id: number) => {
      ZaloRepository.createCheckInByUser(id)
          .then((response) => {
            const emp = ref({} as EmployeeInHospital);
            listEmployee.value.forEach(x => {
              if(x.id == employeeId.value){
                emp.value = x;
              }
            })
            employeeId.value = 0;
            toast.add({
              severity: 'success',
              summary: 'CheckIn hộ thành công',
              detail: 'CheckIn hộ (Nhân viên: ' + emp.value.fullName +') thành công',
              life: 4000
            });
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    getListEmployee();

    return {
      listEmployee,
      createCheckIn,
      employeeId
    }
  }
}

